import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { String } from 'typescript-string-operations';
import { RootService } from './root.service';

@Injectable({
  providedIn: 'root'
})
export class ImpactsService {

  BaseURI : string ;

  constructor(private http:HttpClient,private rootService : RootService) {
    this.BaseURI =  this.rootService.GetBaseURL();
   }

  getImpactList(productId,problemId){   
     return this.http.get<any>(String.Format(this.BaseURI + '/CSP/get-impacts/{0}/{1}', productId,problemId)).pipe(map( res => <any>res));
  }
}
